/**
 * Gerbang URL untuk kolom `icon_url` master katalog — DI-SHARE oleh merek
 * (`product_brands.icon_url`, mig 096) dan kategori (`product_categories.icon_url`,
 * mig 0951). Hanya URL `http(s)://…` atau path lokal berawalan `/` yang lolos;
 * selain itu `null`.
 *
 * Kolomnya teks bebas: isinya bisa sisa unggahan lama, hasil edit manual di DB,
 * atau spasi. Tanpa gerbang ini nilai sembarang tayang sebagai gambar RUSAK —
 * lebih buruk daripada jatuh ke ikon bawaan. Skema selain http/https (mis.
 * `javascript:`) ditolak; `//host` protocol-relative juga, karena ia bukan path
 * lokal meski diawali garis miring.
 *
 * Sengaja dipisah dari `brands.ts`: begitu kategori memakai gerbang yang sama,
 * memanggil fungsi bernama "brand" dari jalur kategori jadi menyesatkan.
 */
export function normalizeIconUrl(raw: string | null | undefined): string | null {
  const s = (raw ?? "").trim();
  if (!s) return null;
  if (s.startsWith("//")) return null;
  if (s.startsWith("/")) return s;
  try {
    const url = new URL(s);
    return url.protocol === "https:" || url.protocol === "http:" ? s : null;
  } catch {
    return null;
  }
}
